module.exports = __webpack_public_path__ + "media/assets/images/blog/AWS_Elastic_Load_Balancer-d0f6b5e35865baf565daf247b8e32821.png";